module.exports = __webpack_public_path__ + "assets/adas.bfd03c02.svg";